import { extend, $$ } from './HelperFunctions'

export class Counter {
  constructor (settings, selectors, classes) {
    this.settings = extend({
      startToEndDuration: 2,
      startToEndRefreshTiming: 0.05,
      intervalTiming: 1
    }, settings)

    this.selectors = extend({
      counter: '.counter:not(.counter--started):not(.counter--broken)'
    }, selectors)

    this.classes = extend({
      counterStarted: 'counter--started',
      counterBroken: 'counter--broken'
    }, classes)
  }

  init () {
    const counters = $$(this.selectors.counter)

    counters.forEach((counter) => {
      if (counter.dataset.counterStart) {
        counter.textContent = counter.dataset.counterStart
      }
    })

    this.checkCounterStart()
    this.addEvents()
  }

  addEvents () {
    const that = this
    let resizeTimer

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)

      resizeTimer = setTimeout(function () {
        that.checkCounterStart()
      }, 250)
    })

    window.addEventListener('scroll', () => {
      that.checkCounterStart()
    })
  }

  checkCounterStart () {
    const that = this
    const counters = $$(that.selectors.counter)
    const screenHeight = window.innerHeight
    const scrollTop = window.scrollY

    counters.forEach((counter) => {
      const counterOffset = counter.getBoundingClientRect()
      const counterOffsetTop = counterOffset.top + window.scrollY
      const counterOffsetBottom = counterOffsetTop + counter.offsetHeight

      if (counter.dataset.counterType === 'start-to-end') {
        if ((scrollTop - Math.round(screenHeight * 0.2)) > (counterOffsetTop - screenHeight) && (scrollTop + Math.round(screenHeight * 0.2)) < counterOffsetBottom) {
          that.startToEnd(counter)
        }
      } else if (counter.dataset.counterType === 'infinite') {
        that.infinite(counter)
      } else {
        console.log('%cCounter: incomplete Setup', 'color: #ff0000;')
        console.log(counter)
        counter.classList.add(that.classes.counterBroken)
      }
    })
  }

  startToEnd (counter) {
    const that = this

    if (counter) {
      counter.classList.add(that.classes.counterStarted)

      const counterStart = parseFloat(counter.dataset.counterStart) || 0

      if (counter.dataset.counterEnd !== '') {
        const counterEnd = parseInt(counter.dataset.counterEnd)
        const counterDuration = parseInt(counter.dataset.counterDuration) || that.settings.startToEndDuration
        const counterRefreshTiming = parseInt(counter.dataset.counterRefreshTiming) || that.settings.startToEndRefreshTiming
        let counterDurationSteps
        let counterDirection = 'up'

        counter.dataset.counterValue = counterStart
        counter.textContent = that.formatText(counterStart, counter)

        if (counterStart < counterEnd) {
          counterDurationSteps = parseFloat((counterEnd - counterStart) / (counterDuration / counterRefreshTiming))
        } else {
          counterDurationSteps = parseFloat((counterStart - counterEnd) / (counterDuration / counterRefreshTiming))
          counterDirection = 'down'
        }

        const countInterval = setInterval(() => {
          let newValue

          if (counterDirection === 'up') {
            newValue = parseFloat(counter.dataset.counterValue) + counterDurationSteps
          } else {
            newValue = parseFloat(counter.dataset.counterValue) - counterDurationSteps
          }

          if ((newValue >= counterEnd && counterDirection === 'up') || (newValue <= counterEnd && counterDirection === 'down')) {
            counter.dataset.counterValue = parseFloat(counterEnd)
            counter.textContent = that.formatText(counterEnd, counter)

            clearInterval(countInterval)
          } else {
            counter.dataset.counterValue = newValue
            counter.textContent = that.formatText(parseInt(newValue), counter)
          }
        }, (counterRefreshTiming * 1000))
      } else {
        console.log('%cCounter: incomplete Setup', 'color: #ff0000;')
        console.log(counter)
      }
    }
  }

  infinite (counter) {
    const that = this

    if (counter) {
      counter.classList.add(that.classes.counterStarted)

      const now = Date.now()
      const counterStart = parseInt(counter.dataset.counterStart) || 0

      if (counter.dataset.counterIntervalValue !== '' && parseInt(counter.dataset.counterStartTimestamp) < now) {
        const counterStartTimestamp = parseInt(counter.dataset.counterStartTimestamp)
        const counterIntervalValue = parseFloat(counter.dataset.counterIntervalValue)
        const counterIntervalTiming = parseInt(counter.dataset.counterIntervalTiming) || that.settings.intervalTiming
        const calculatedStart = counterStart + Math.floor((((now / 1000) - counterStartTimestamp) / counterIntervalTiming) * counterIntervalValue)

        counter.dataset.counterValue = calculatedStart
        counter.textContent = that.formatText(calculatedStart, counter)

        window.setInterval(() => {
          counter.dataset.counterValue = Math.floor(parseFloat(counter.dataset.counterValue) + counterIntervalValue)
          counter.textContent = that.formatText(parseInt(counter.dataset.counterValue), counter)
        }, (counterIntervalTiming * 1000))
      } else {
        console.log('%cCounter: incomplete Setup', 'color: #ff0000;')
        console.log(counter)
      }
    }
  }

  formatText (value, counter) {
    if (counter.dataset.counterFormat === false || counter.dataset.counterFormat === 'false' || counter.dataset.counterFormat === '0') {
      return value
    } else if (counter.dataset.counterComma) {
      return this.formatCommaAndPoint(value)
    } else {
      return this.formatPoint(value)
    }
  }

  formatPoint (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  formatCommaAndPoint (value) {
    const valueString = value.toString()

    if (valueString.length > 2) {
      const first = valueString.substr(0, valueString.length - 2)
      const last = valueString.substr(valueString.length - 2, 2)

      return first.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + last
    } else if (valueString.length > 1) {
      return '0,' + valueString
    } else {
      return '0,0' + valueString
    }
  }
}

export default Counter
